
import { Component, OnInit } from '@angular/core';


@Component({
    selector: 'app-gestao-beneficios',
    templateUrl: './gestao-beneficios.component.html',
    styleUrls: ['./gestao-beneficios.component.css']
})
export class GestaoBeneficiosComponent implements OnInit {

    constructor() {

    }

    ngOnInit() {

    }
}
